import { icons } from './icons';
import { ThemeUICSSObject } from '@apia/theme';
const iconsFunctionalities: ThemeUICSSObject = {
  icons,
};

export { iconsFunctionalities };
